enum PdfTemplateName {
  PURCHASE_ORDER_INVOICE = "PURCHASE_ORDER_INVOICE",
  PURCHASE_ORDER_RECEIPT = "PURCHASE_ORDER_RECEIPT",
  POST_EVENT_SUMMARY = "POST_EVENT_SUMMARY"
}

export default PdfTemplateName;
